import { DefaultSEOConfig } from "../components/SEO/types";

/**
 * Default SEO Configuration
 * Centralized configuration for consistent SEO across the application
 */
export const defaultSEOConfig: DefaultSEOConfig = {
  // Basic defaults
  defaultTitle: "就活ダッシュボード",
  titleTemplate: "%s | 就活ダッシュボード",
  defaultDescription:
    "就活ダッシュボードは新卒就職活動を効率化する無料ツールです。企業情報、選考状況、面接スケジュールを一元管理。ES締切も逃さず、内定までサポート。",

  // Site configuration
  siteUrl: process.env.REACT_APP_SITE_URL || "https://jobshunt.org",
  defaultImage: "/og-image.png",
  twitterHandle: "@jobshunt_org",

  // Keywords
  defaultKeywords: [
    "就活",
    "就職活動",
    "新卒",
    "企業管理",
    "選考管理",
    "スケジュール管理",
    "ES締切",
    "面接",
    "内定",
    "就活アプリ",
    "就活ツール",
    "就活サポート",
  ],

  // Localization
  defaultLocale: "ja_JP",
  defaultLang: "ja",
};

/**
 * Common structured data templates
 */
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "就活ダッシュボード",
  url: defaultSEOConfig.siteUrl,
  logo: `${defaultSEOConfig.siteUrl}/logo192.png`,
  description: defaultSEOConfig.defaultDescription,
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "Customer Service",
    url: `${defaultSEOConfig.siteUrl}/contact`,
  },
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "就活ダッシュボード",
  url: defaultSEOConfig.siteUrl,
  description: defaultSEOConfig.defaultDescription,
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: `${defaultSEOConfig.siteUrl}/companies?search={search_term_string}`,
    },
    "query-input": "required name=search_term_string",
  },
};

export const webApplicationSchema = {
  "@context": "https://schema.org",
  "@type": "WebApplication",
  name: "就活ダッシュボード",
  url: defaultSEOConfig.siteUrl,
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web Browser",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "JPY",
  },
  description: defaultSEOConfig.defaultDescription,
};
